<template>
<el-dialog class='profile-account-cellphone-dialog' title='手机号认证' size='tiny' :visible.sync="dialogVisible">
  <p class='hint'>绑定手机号可以用来登录和找回密码。</p>

  <el-form ref="cellphone">
    <cellphone-input ref="cellphoneInput" :cellphone.sync="cellphone" :captcha.sync="captcha" />
  </el-form>

  <div slot='footer' class='dialog-footer'>
    <el-button type='text' @click="close()">取消</el-button>
    <el-button type='primary' @click="save()">提交</el-button>
  </div>
</el-dialog>
</template>

<script>
export default {
  data() {
    return {
      cellphone: null,
      captcha: null,
      dialogVisible: false
    }
  },
  methods: {
    open() {
      this.cellphone = this.$store.state.user.info.cellphone
      this.dialogVisible = true
    },
    close() {
      this.cellphone = null
      this.captcha = null
      this.dialogVisible = false
    },
    save() {
      let vm = this
      let cellphoneInput = vm.$refs['cellphoneInput']
      // do save for cellphone-input
      cellphoneInput.save().then(_ => {
        // when save passed validation
        vm.$store.dispatch('user/update', {
          cellphone: vm.cellphone,
          captcha: vm.captcha
        }).then(_ => {
          vm.close()
        }).catch(err => {
          let data = err.response.data
          if (data.type === 'RecordInvalidError') {
            // 手机已被占用
            data.errors.forEach(err => {
              let field = err.field
              let message = err.details.map(d => d.message).join(',')
              cellphoneInput.addErrors(field, message)
            })
          } else if (data.type === 'CaptchaIncorrectError') {
            cellphoneInput.addErrors('captcha', data.message)
          }
        })
      }).catch(_ => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// cellphone.dialog.vue?636cfaf5